import { useEffect, useRef } from "react";
import { listeners, type EventListener, type EventMap } from "@/lib/event-bus";

export function useEventListener<K extends keyof EventMap>(
  event: K,
  handler: EventListener<EventMap[K]>,
) {
  const saved = useRef(handler);
  useEffect(() => {
    saved.current = handler;
  });

  useEffect(() => {
    const wrapped = ((payload: never) =>
      saved.current(payload)) as EventListener<never>;
    let set = listeners.get(event);
    if (!set) {
      set = new Set();
      listeners.set(event, set);
    }
    set.add(wrapped);
    return () => {
      set.delete(wrapped);
      if (set.size === 0) listeners.delete(event);
    };
  }, [event]);
}
